<div class="g-0">
    <div class="col">
        <div class="box-wrapper">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-user-group"></i>
                                <span class="ms-2">Responsabili Proiect</span>
                            </div>
                            <button
                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                class="btn btn-small btn-primary edit-btn" (click)="toggleEditField()">
                                <i class="fa fa-pencil" *ngIf="!showEditField"></i>
                                <i class="fa fa-close" *ngIf="showEditField"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Responsabil</th>
                            <th scope="col">Telefon</th>
                            <th scope="col">Responsabil Principal?</th>
                            <th scope="col" *ngIf="showEditField">Acțiuni</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let responsabil of responsabiliProiect; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>{{ responsabil.name }}</td>
                            <td>{{ responsabil.telefon || 'n/a' }}</td>
                            <td>{{ responsabil.primary_agent === 1 ? 'DA' : 'NU' }}</td>
                            <td *ngIf="showEditField">
                                <div class="d-flex align-center">
                                    <button *ngIf="responsabil.primary_agent !== 1" type="button"
                                        class="btn btn-sm btn-success action-button me-1" title="Responsabil"
                                        (click)="setPrimaryResponsabil(responsabil.id)">
                                        Responsabil
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger action-button" title="Șterge"
                                        (click)="removeResponsabil(responsabil.id)">
                                        <img class="btn-img" src="/assets/icons/delete.svg" alt="delete" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ng-container *ngIf="showEditField">
                    <form class="p-1" [formGroup]="form" (submit)="submitForm()">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Direcție</mat-label>
                                    <mat-select formControlName="id_directie"
                                        (selectionChange)="onDirectieChange($event.value)">
                                        <mat-option *ngFor="let row of directiiActive" [value]="row.id">
                                            {{ row.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['id_directie'].valid && form.controls['id_directie'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Compartiment</mat-label>
                                    <mat-select formControlName="id_compartiment"
                                        (selectionChange)="searchResponsabili()">
                                        <mat-option *ngFor="let row of compartimenteActive$ | async" [value]="row.id">
                                            {{ row.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['id_compartiment'].valid && form.controls['id_compartiment'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Responsabil</mat-label>
                                    <mat-select formControlName="id_responsabil">
                                        <mat-option *ngFor="let row of responsabiliDepartament$ | async"
                                            [value]="row.id">
                                            {{ row.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['id_responsabil'].valid && form.controls['id_responsabil'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2 d-flex align-items-center">
                                <button class="btn btn-small btn-primary" type="submit" [disabled]="form.invalid">
                                    Adaugă
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>